import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: "DOs and DON'Ts of an Automobile Accident" },
	{
		name: 'description',
		content: 'What to do and what not to do after an automobile accident.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">
				DOs and DON'Ts of an Automobile Accident
			</h1>
			<h3>DOs</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Do remain calm and professional.
				<br />
				Do call the police and, if necessary, the ambulance.
				<br />
				Do obtain the names, phone numbers, and addresses of all drivers,
				witnesses, and injured persons.
				<br />
				Do take pictures of the vehicle and surroundings and any other pertinent
				information. With the high availability of cameras and camera-phones, a
				photo is easy to capture and can be useful later on.
				<br />
				Do be completely honest and forthright. Dishonesty can invalidate your
				coverage.
				<br />
				Do save all receipts for repairs, towing, rental car, medical bills, and
				other expenses incurred as a result of the accident.
				<br />
				Do report the accident to your insurance agent as soon as possible.
			</p>
			<h3>DON'Ts</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Don't leave the scene of the accident. It's illegal.
				<br />
				Don't drive an unsafe vehicle. If you have any question as to the safety
				of your vehicle after an accident, don't even think about driving it
				away. It's not worth the risk.
				<br />
				Don't accept any claim settlements at the scene of the accident.
				<br />
				Don't admit liability on your part. Relate just the facts to the police
				officer.
			</p>
		</>
	)
}
